var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.643,
    height: 80.657,
    viewBox: "0 0 78.643 80.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".search-icon-inner-circle,.b{fill:none;stroke-linecap:round;stroke-linejoin:round;}.b{stroke:#a5a9c7;stroke-width:8px;}.c,.d{stroke:none;}.d{fill:#a5a9c7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3485 -84)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "search-icon-inner-circle",
    transform: "translate(3480.5 79.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.95,39.725A35.225,35.225,0,1,1,39.725,4.5,35.225,35.225,0,0,1,74.95,39.725Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 39.72501754760742 12.5 C 24.71308898925781 12.5 12.5 24.71308898925781 12.5 39.72501754760742 C 12.5 54.73694610595703 24.71308898925781 66.95003509521484 39.72501754760742 66.95003509521484 C 54.73694610595703 66.95003509521484 66.95003509521484 54.73694610595703 66.95003509521484 39.72501754760742 C 66.95003509521484 24.71308898925781 54.73694610595703 12.5 39.72501754760742 12.5 M 39.72501754760742 4.5 C 59.17925262451172 4.5 74.95003509521484 20.27078247070312 74.95003509521484 39.72501754760742 C 74.95003509521484 59.17925262451172 59.17925262451172 74.95003509521484 39.72501754760742 74.95003509521484 C 20.27078247070312 74.95003509521484 4.5 59.17925262451172 4.5 39.72501754760742 C 4.5 20.27078247070312 20.27078247070312 4.5 39.72501754760742 4.5 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.071,40.071l-15.1-15.1",
    transform: "translate(3517.915 118.929)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchImage);
export default __webpack_public_path__ + "static/media/search-image.b1939d0b.svg";
export { ForwardRef as ReactComponent };